import { useEffect, useState } from 'react';
import axios from 'axios';

const SETTINGS_URL = `${process.env.REACT_APP_BACKEND_URL || ''}/api/app-settings`;

// Department visibility is independent of the station's explicit operating mode.
export const useStationMode = () => {
  const [isSingleDepartment, setIsSingleDepartment] = useState(
    () => window.APP_CONFIG?.department_mode === 'single'
  );
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    let request = 0;
    const refresh = async () => {
      const currentRequest = ++request;
      try {
        const response = await axios.get(SETTINGS_URL);
        if (!mounted || currentRequest !== request) return;
        const mode = response.data?.department_mode === 'single' ? 'single' : 'multi';
        window.APP_CONFIG = { ...window.APP_CONFIG, department_mode: mode };
        setIsSingleDepartment(mode === 'single');
      } catch {
        // Keep the last known mode when the settings service is unavailable.
      } finally {
        if (mounted && currentRequest === request) setLoading(false);
      }
    };
    refresh();
    window.addEventListener('focus', refresh);
    return () => {
      mounted = false;
      window.removeEventListener('focus', refresh);
    };
  }, []);

  return { isSingleDepartment, loading };
};
